// remove the banner when user clicks on close button
const usBannerCloseButton = document.querySelector('.us-content-banner-close');
if (usBannerCloseButton) {
	usBannerCloseButton.addEventListener('click', () => {
		const banner = document.getElementsByClassName('us-content-banner')[0];
		banner.remove();
	});
}
